var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApi = function SvgApi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4898_8267)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    stroke: "#121212",
    d: "M7 1.5H17C20.0376 1.5 22.5 3.96243 22.5 7V17C22.5 20.0376 20.0376 22.5 17 22.5H7C3.96243 22.5 1.5 20.0376 1.5 17V7C1.5 3.96243 3.96243 1.5 7 1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M4.11744 17C4.01566 17 3.98004 16.944 4.01057 16.8321L6.52965 7.12214C6.55001 7.04071 6.60599 7 6.69759 7H8.27011C8.35154 7 8.40752 7.04071 8.43805 7.12214L10.9877 16.8321C11.008 16.944 10.9673 17 10.8655 17H9.56782C9.50675 17 9.45586 16.9593 9.41515 16.8779L7.91897 10.4656C7.83754 10.1298 7.76121 9.79389 7.68996 9.45802C7.61871 9.12214 7.54747 8.78117 7.47622 8.43511H7.44568C7.38462 8.78117 7.31846 9.12214 7.24721 9.45802C7.17596 9.78372 7.10472 10.1196 7.03347 10.4656L5.53729 16.8779C5.51693 16.9593 5.46095 17 5.36935 17H4.11744ZM5.79683 14.7405L6.05637 13.4885H8.86553L9.15561 14.7405H5.79683Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M12.0114 17C11.9198 17 11.874 16.9491 11.874 16.8473V7.15267C11.874 7.05089 11.9198 7 12.0114 7H14.1335C15.1819 7 15.9605 7.26463 16.4694 7.79389C16.9783 8.31298 17.2328 9.10687 17.2328 10.1756C17.2328 11.1934 16.9732 11.9771 16.4542 12.5267C15.9452 13.0662 15.1819 13.3359 14.1641 13.3359H13.3244V16.8473C13.3244 16.9491 13.2786 17 13.187 17H12.0114ZM13.3244 12.0382H14.1183C14.6984 12.0382 15.1208 11.8906 15.3855 11.5954C15.6501 11.2901 15.7824 10.827 15.7824 10.2061C15.7824 9.53435 15.645 9.05089 15.3702 8.75573C15.1056 8.45038 14.6933 8.29771 14.1335 8.29771H13.3244V12.0382Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M18.7206 17C18.629 17 18.5832 16.9491 18.5832 16.8473V7.15267C18.5832 7.05089 18.629 7 18.7206 7H19.8962C19.9878 7 20.0336 7.05089 20.0336 7.15267V16.8473C20.0336 16.9491 19.9878 17 19.8962 17H18.7206Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4898_8267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export default SvgApi;